export const getMaskedString = (length: number) => {
  return "*".repeat(length)
}

export const getTruncatedSecretKey = (secret: string) => {
  return `${secret.slice(0, 8)}...${secret.slice(-8)}`
}
